"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBannerImageContainerHeight = void 0;
exports.getBannerImageContainerHeight = function (containerWidth, imageWidth, imageHeight) {
    if (!!containerWidth && !!imageWidth && !!imageHeight) {
        return (containerWidth * imageHeight) / imageWidth;
    }
    else {
        return undefined;
    }
};
